import {
  Required,
  DataValidator,
  transformKeys,
  IsString,
} from "@/utils/type-vaildator";
import api from "./api";

export interface CreateSubscriptionRequest {
  sku: string;
  cancelSub?: string;
  teamCode: string;
  email: string;
  successJumpUrl: string;
  failJumpUrl: string;
}

interface CreateSubscriptionResponse {
  session_id: string;
  url: string;
  amount: number;
  currency: string;
  status: string;
}

export class CreateSubscriptionData {
  @Required("url cannot be empty")
  @IsString("url must be a string")
  url: string;
}

const transformAndValidateData = (
  response: CreateSubscriptionResponse
): CreateSubscriptionData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, CreateSubscriptionData);
  } catch (error) {
    console.error("Create subscription data validation failed:", error.message);
    throw error;
  }
};

/** 创建订阅 */
export const createSubscription = async ({ sku, teamCode, email, cancelSub, successJumpUrl, failJumpUrl }: CreateSubscriptionRequest) => {
  const res = await api.get<CreateSubscriptionResponse>('/pay/create/subscription', {
    sku,
    email,
    team_code: teamCode,
    cancel_sub: cancelSub,
    success_jump_url: successJumpUrl,
    fail_jump_url: failJumpUrl,
  });
  const data = transformAndValidateData(res.data);
  return data;
}